import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import MobileBar from "@/components/site/MobileBar";
import CookieNotice from "@/components/site/CookieNotice";
import Home from "@/pages/Home";
import ComingSoon from "@/pages/ComingSoon";
import RequestRepair from "@/pages/RequestRepair";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Services from "@/pages/Services";
import About from "@/pages/About";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudy from "@/pages/CaseStudy";

let lenis = null;

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PAGES = [
];

function App() {
  return (
    <div className="grain min-h-screen bg-[var(--ink)]">
      <BrowserRouter>
        <SmoothScroll />
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-black focus:px-4 focus:py-2">Skip to content</a>
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/request-a-repair" element={<RequestRepair />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/repairs-services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            {PAGES.map((p) => (
              <Route key={p.path} path={p.path} element={<ComingSoon title={p.title} />} />
            ))}
            <Route path="*" element={<ComingSoon title="Page not found" />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
        <CookieNotice />
      </BrowserRouter>
    </div>
  );
}

export default App;
